module.exports = __webpack_public_path__ + "static/wool-cca29e78a35a4c741bd4ee4dbae4ceff.jpeg";